module.exports = __webpack_public_path__ + "img/icon-40.e7ed0443.svg";